import styled, { css } from 'styled-components';

interface InputProps {
  placeholder?: string;
  type: string;
  width: string;
  theme: string;
  value: string;
  setValue: (value: string) => void;
}

const Input = ({
  placeholder,
  type,
  width,
  theme,
  value,
  setValue,
}: InputProps) => {
  return (
    <>
      <Wrap
        placeholder={placeholder}
        type={type}
        $width={width}
        $theme={theme}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    </>
  );
};

export default Input;

const Wrap = styled.input<{
  $theme: string;
  $width: string;
}>`
  width: ${({ $width }) => $width};
  min-width: ${({ $width }) => $width};
  box-sizing: border-box;
  ${({ $theme }) => {
    if ($theme === 'type1') {
      return css`
        height: 36px;
        border-radius: 4px;
        background-color: #fff;
        border: 1px solid #d6dbe1;
        color: #111;
        padding: 0 12px;
        font-size: 14px;
        &::placeholder {
          color: #666683;
        }
      `;
    }
  }}
  ${({ $theme }) => {
    if ($theme === 'type2') {
      return css`
        height: 36px;
        border-radius: 4px;
        background-color: #fff;
        border: 1px solid #d6dbe1;
        color: #111;
        padding: 0 8px;
        font-size: 12px;
        &::placeholder {
          color: #666683;
        }
      `;
    }
  }}
`;
